export async function timeOrAction(requestAPI: any, timeOut = 1000) {
  const setTimerOut = new Promise((resolve) => {
    setTimeout(resolve, timeOut, { success: false });
  });
  return await Promise.race([requestAPI, setTimerOut])
    .then((value) => {
      const data = value || null;
      const successData = 'success' in data ? data?.success : !!data;
      return { success: successData, data };
    })
    .catch((error) => {
      return { success: false, error };
    });
}
